/* Lógica de Pestañas (Tabs) MFB */
document.addEventListener('DOMContentLoaded', function() {
  
  // Buscamos todas las secciones tabuladas de la página
  const tabbedSections = document.querySelectorAll('[data-section-type="tabbed-products"]');

  tabbedSections.forEach(section => {
    const tabButtons = section.querySelectorAll('.js-tab-button');
    const tabContents = section.querySelectorAll('.js-tab-content');

    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        // 1. Desactivamos todas las pestañas de esta sección
        tabButtons.forEach(btn => btn.classList.remove('tabbed-image-products__tab--active'));
        
        // 2. Activamos la pestaña clicada
        this.classList.add('tabbed-image-products__tab--active');

        // 3. Ocultamos todas las grillas de esta sección
        tabContents.forEach(content => {
          content.classList.remove('tabbed-image-products__product-grid--active');
          content.classList.add('tabbed-image-products__product-grid--hidden');
        });

        // 4. Mostramos la grilla correspondiente
        const tabId = this.getAttribute('data-tab-id');
        const activeContent = section.querySelector(`#${tabId}`);
        if (activeContent) {
          activeContent.classList.remove('tabbed-image-products__product-grid--hidden');
          activeContent.classList.add('tabbed-image-products__product-grid--active');
        }
      });
    });
  });
});